import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { Empty } from "@/components/common";
import { fmtDT } from "@/lib/format";
import { cn } from "@/lib/utils";

const TONE = { in_attesa: "bg-amber-100 text-amber-800", eseguita: "bg-emerald-100 text-emerald-800", rifiutata: "bg-zinc-200 text-zinc-700", approvata_non_eseguita: "bg-red-100 text-red-700", in_esecuzione: "bg-sky-100 text-sky-800" };
const LABEL = { in_attesa: "In attesa", eseguita: "Approvata ed eseguita", rifiutata: "Rifiutata", approvata_non_eseguita: "Approvata, non eseguita", in_esecuzione: "In esecuzione" };

const Row = ({ p, onDone }) => {
  const [note, setNote] = useState("");
  const decide = async (decision) => {
    try {
      const { data } = await api.post(`/toth/proposals/${p.id}/decision`, { decision, note });
      toast[data.status === "approvata_non_eseguita" ? "error" : "success"](data.outcome || `Proposta ${decision}`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="card-soft p-5" data-testid={`toth-proposal-${p.id}`}>
      <div className="flex flex-wrap items-start gap-2">
        <p className="min-w-0 flex-1 font-bold">{p.title}</p>
        <span className={cn("rounded-full px-2.5 py-0.5 text-xs font-bold", TONE[p.status] || "bg-muted")} data-testid={`toth-proposal-status-${p.id}`}>{LABEL[p.status] || p.status}</span>
      </div>
      <p className="mt-1 text-sm text-muted-foreground">{p.description}</p>
      <p className="mt-2 text-xs text-muted-foreground">Richiesta da {p.requested_by_name} · {fmtDT(p.created_at)}{p.target?.code && ` · ${p.target.code}`}</p>
      {p.status === "in_attesa" ? (
        <div className="mt-3 flex flex-col gap-2 sm:flex-row">
          <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Nota (facoltativa)" className="rounded-xl" data-testid={`toth-proposal-note-${p.id}`} />
          <Button onClick={() => decide("approvata")} className="rounded-xl" data-testid={`toth-proposal-approve-${p.id}`}>Approva ed esegui</Button>
          <Button variant="destructive" onClick={() => decide("rifiutata")} className="rounded-xl" data-testid={`toth-proposal-reject-${p.id}`}>Rifiuta</Button>
        </div>
      ) : <p className="mt-2 text-xs font-semibold">{p.outcome} · {p.decided_by_name} · {fmtDT(p.decided_at)}</p>}
    </div>
  );
};

export const ProposalsPanel = () => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => {
    api.get("/toth/proposals").then((r) => setRows(r.data));
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  if (!rows) return <p className="text-muted-foreground">Caricamento…</p>;
  if (!rows.length) return <Empty text="Nessuna proposta. Chiedi a Toth in chat di preparare un sollecito, una nuova scadenza, una riassegnazione o un nuovo ordine." testid="toth-proposals-empty" />;
  return <div className="space-y-3" data-testid="toth-proposals-list">{rows.map((p) => <Row key={p.id} p={p} onDone={load} />)}</div>;
};
